import { CANONICAL, CANONICAL_TO_GIFI } from "../constants/CanonicalCodes";

const CanonicalValidationService = {
	/**
	 * Validates the client CANONICAL / CANONICAL_TO_GIFI constants against the server's
	 * authoritative canonical taxonomy: every client code must exist server-side, and any
	 * GIFI specified on both sides must match. Server-only codes surface as warnings.
	 * @param {Array<Object>} serverAccounts entries of { canonical_code, gifi_code, display_name }
	 * @return {{ ok: Boolean, errors: Array<String>, warnings: Array<String> }}
	 */
	validateAgainstServerTaxonomy(serverAccounts) {
		if (!Array.isArray(serverAccounts)) {
			return { ok: true, errors: [], warnings: ["Server returned no canonical taxonomy — validation skipped"] };
		}
		if (serverAccounts.length === 0) {
			return { ok: true, errors: [], warnings: ["Server returned an empty canonical taxonomy — validation skipped"] };
		}

		let serverByCode = {};
		for (let a of serverAccounts) {
			if (a && a.canonical_code) serverByCode[a.canonical_code] = a;
		}

		let errors = [];
		let warnings = [];

		for (let key of Object.keys(CANONICAL)) {
			let code = CANONICAL[key];
			let serverEntry = serverByCode[code];
			if (!serverEntry) {
				errors.push("CANONICAL." + key + " = '" + code + "' — server doesn't recognize this canonical code (add it to canonical_taxonomy_seed.js, or remove it from constants.js)");
				continue;
			}
			let clientGifi = CANONICAL_TO_GIFI[code];
			let serverGifi = serverEntry.gifi_code;
			if (clientGifi != null && serverGifi != null && Number(clientGifi) !== Number(serverGifi)) {
				errors.push("CANONICAL." + key + " (" + code + "): client maps to GIFI " + clientGifi + ", server says GIFI " + serverGifi + " — one of them is wrong");
			}
		}

		let clientCodes = new Set(Object.values(CANONICAL));
		let serverOnlyCount = 0;
		for (let code of Object.keys(serverByCode)) {
			if (!clientCodes.has(code)) serverOnlyCount++;
		}
		if (serverOnlyCount > 0) {
			warnings.push("Server has " + serverOnlyCount + " canonical code(s) the client doesn't reference (informational — add to CANONICAL when needed)");
		}

		return { ok: errors.length === 0, errors: errors, warnings: warnings };
	},
};

export default CanonicalValidationService;
